import {
  SET_IS_OPENED,
  SET_SELECTED_PREFERRED_CONDITIONS,
  SET_ORDER,
  SET_ORDER_BY,
  PreferredConditionsMatchingHorsesSliderType,
  REMOVE_HORSE_ID
} from "store/actions/preferredConditionsMatchingHorsesSlider";
import PreferredConditionsMatchingHorsesSliderState from "interfaces/PreferredConditionsMatchingHorsesSliderState";
import { SortOrder } from "interfaces/SortOrder";

const initialState: PreferredConditionsMatchingHorsesSliderState = {
  isOpened: false,
  order: SortOrder.ASC,
  orderBy: "horseName"
};

export default (
  state = initialState,
  action: PreferredConditionsMatchingHorsesSliderType
): PreferredConditionsMatchingHorsesSliderState => {
  switch (action.type) {
    case SET_IS_OPENED:
      return {
        ...state,
        isOpened: action.isOpened
      };
    case SET_SELECTED_PREFERRED_CONDITIONS:
      return {
        ...state,
        selectedPreferredConditions: action.selectedPreferredConditions
      };
    case SET_ORDER:
      return {
        ...state,
        order: action.order
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderBy: action.orderBy
      };
    case REMOVE_HORSE_ID:
      return {
        ...state,
        selectedPreferredConditions: {
          ...state.selectedPreferredConditions,
          horseIds: state.selectedPreferredConditions.horseIds.filter(
            id => id !== action.horseId
          )
        }
      };
    default:
      return state;
  }
};
